import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { AirSearchCardModel } from "./model";

type AirSearchCard = AirSearchCardModel[];

const initialAppState: AirSearchCard = [];

const airSearchCardSlice = createSlice({
  name: "airSearchCards",
  initialState: initialAppState,
  reducers: {
    prependSearchCardAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: AirSearchCardModel; unique?: boolean }>
    ) => {
      if (unique) {
        const foundCard = state.find((card) => card.reference === data.reference);
        if (foundCard) return;
      }
      state.unshift(data);
    },
    removeSearchCardAction: (state, action: PayloadAction<AirSearchCardModel>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    updateSearchCardAction: (state, action: PayloadAction<AirSearchCardModel>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const airSearchCardBaseSelector = createBaseSelector(airSearchCardSlice);

registerSlice([airSearchCardSlice]);

export const airSearchCardStore = {
  actions: airSearchCardSlice.actions,
  selectors: {
    searchCards: createSelector(airSearchCardBaseSelector, (s) => s),
  },
};
